import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
// import { FooterComponent } from './footer/footer.component';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { SidebarService } from '../@core/services/signals/sidebar.services';

@Component({
  selector: 'app-layouts',
  standalone: true,
  imports: [
    CommonModule,
    SidebarComponent,
    NavbarComponent,
    RouterOutlet,
    FooterComponent,
  ],
  templateUrl: './layouts.component.html',
  styleUrl: './layouts.component.scss',
})
export class LayoutsComponent implements AfterViewInit {
  isSidebarOpen$!: Observable<boolean>;
  private shouldScroll = true; //    Track whether to scroll or not

  constructor(private router: Router, private elRef: ElementRef) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.shouldScroll = true; //    Allow scrolling only when route changes
        setTimeout(() => this.scrollToTop(), 50);
      }
    });
  }
  
  ngAfterViewInit(): void {
    setTimeout(() => this.scrollToTop(), 50);
  }

  sidebarService = inject(SidebarService);
  scrollToTop() {
    if (!this.shouldScroll) return; //    Prevent unnecessary scrolling

    const mainContent = this.elRef.nativeElement.querySelector('.main-content'); 
    if (mainContent) {
      mainContent.scrollTo({ top: 0, behavior: 'smooth' });
      this.shouldScroll = false; //    Reset flag to prevent auto-scrolling on user interaction
    }
  }
}
